@if (section && item) {
<section
  class="pia-entryContentBlock pia-entryContentBlock-section{{ section.id }}"
>
  <header autoscroll="true" class="pia-entryContentBlock-header">
    <div>
      <fa-icon [icon]="faSitemap"></fa-icon>
    </div>
    <div class="pia-entryContentBlock-header-title">
      @if (section.title) {
      <h1>{{ section.title | translate }}</h1>
      } @if (section.short_help) {
      <h3>{{ section.short_help | translate }}</h3>
      } @if (item.title) {
      <h2>{{ item.title | translate }}</h2>
      } @if (item.short_help) {
      <h4>{{ item.short_help | translate }}</h4>
      }
    </div>
  </header>
  @if (item.is_measure) { @if (!structure.is_example) {
  <button
    (click)="addMeasure()"
    class="btn btn-white btn-addMeasure"
    type="button"
  >
    <span class="pia-icons pia-icon-add"></span>
    {{ "measures.add" | translate }}
  </button>
  } @for (measure of item.answers; track measure; let i = $index) {
  <app-measures
    [structure]="structure"
    [id]="i"
    [measure]="measure"
    [section]="section"
    [item]="item"
  ></app-measures>
  } } @else { @for (question of questions; track question) {
  <div>
    <app-questions
      [structure]="structure"
      [question]="question"
      [section]="section"
      [item]="item"
      (questionDeleted)="onQuestionDeleted($event)"
    ></app-questions>
  </div>
  } } @if (!item.is_measure && !structure.is_example) {
  <footer class="pia-entryContentBlock-footer">
    <div>
      <button class="btn btn-green btn-active" (click)="addQuestion()">
        <fa-icon [icon]="faPlus"></fa-icon>
        {{ "pia.footer.structure_add_question" | translate }}
      </button>
    </div>
  </footer>
  }
</section>
}
